import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import AppLayout from "../../components/AppLayout";
import SolicitacoesFornecedor from "../Fornecedores/SolicitacoesFornecedor";

// Rótulo de aba com um contador opcional ao lado (sem sobrepor o texto).
function TabLabel({ text, count }) {
	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
			<span>{text}</span>
			{count > 0 && (
				<Box
					component="span"
					sx={{
						minWidth: 20,
						height: 20,
						px: 0.75,
						borderRadius: "10px",
						bgcolor: "#f57c00",
						color: "white",
						fontSize: "0.7rem",
						fontWeight: 700,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						lineHeight: 1,
					}}
				>
					{count}
				</Box>
			)}
		</Box>
	);
}

// Página única de Solicitações. Cada tipo de solicitação é uma aba.
// Por enquanto há apenas "Fornecedores"; novos tipos entram como novas abas.
function Solicitacoes() {
	const [tab, setTab] = useState(0);
	const [pendentesFornecedor, setPendentesFornecedor] = useState(0);

	return (
		<AppLayout currentPage="solicitacoes">
			<Box sx={{ p: 3 }}>
				<Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
					Solicitações
				</Typography>

				<Tabs
					value={tab}
					onChange={(_, v) => setTab(v)}
					sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}
				>
					<Tab label={<TabLabel text="Fornecedores" count={pendentesFornecedor} />} />
				</Tabs>

				{tab === 0 && (
					<SolicitacoesFornecedor onCountChange={setPendentesFornecedor} />
				)}
			</Box>
		</AppLayout>
	);
}

export default Solicitacoes;
